<script>
import { mapActions } from 'vuex';

export default {
    name: 'TheModalWindow',
    data() {
        return {};
    },
    computed: {
        modalComponent() {
            const getter = this.$store.state.modalStore.modalState.componentGetter;
            return getter ? getter() : null;
        },
        modalActive: {
            get: function () {
                return this.modalComponent !== null;
            },
            set: function (newValue) {
                if (!newValue) {
                    this.$store.dispatch('modalStore/closeModal');
                }
            },
        },
    },
    methods: {
        ...mapActions('modalStore', ['closeModal']),
        handleEvent({ eventName, eventPayload }) {
            const onEvent = this.$store.state.modalStore.modalState.onEvent;
            if (typeof onEvent === 'function') {
                onEvent(eventName, eventPayload);
            }
        },
    },
};
</script>

<template>
    <md-dialog :md-active.sync="modalActive" :md-click-outside-to-close="false">
        <component
            :is="modalComponent"
            v-bind="$store.state.modalStore.modalState.props"
            @modalEvent="handleEvent"
        ></component>
    </md-dialog>
</template>

<style scoped lang="scss"></style>

<style lang="scss">
/* Modified by Martin - 2026-05-12 */
/* Override md-dialog internals to prevent horizontal scroll */
.md-dialog {
    overflow-x: hidden !important;

    .md-dialog-container {
        overflow-x: hidden !important;
        max-width: 100vw;
    }

    .md-dialog-content {
        overflow-x: hidden !important;
    }
}

/* Modified by Martin - 2026-05-12 */
/* Elevate md-menu-content above md-dialog (z-index:110) so Combobox dropdowns are visible */
.md-menu-content {
    z-index: 400 !important;
}
</style>
